export default "__VITE_ASSET__CArVgHHZ__"